module.exports = {
  EDI_EXCHANGE_ALL: "EDI_EXCHANGE_ALL",
  EDI_EXCHANGE_IPC: "EDI_EXCHANGE_IPC",
  EDI_EXCHANGE_706: "EDI_EXCHANGE_706",
  MRD_POD_OVERVIEW: "MRD_POD_OVERVIEW",
  TRACKED_ITEMS_IN_PREDES: "TRACKED_ITEMS_IN_PREDES",
  COMPARATIVE_TRAY_USAGE_941: "COMPARATIVE_TRAY_USAGE_941",
  COMPARATIVE_BAG_USAGE_951: "COMPARATIVE_BAG_USAGE_951",
  COMPARATIVE_PALLET_BOX_USAGE_961: "COMPARATIVE_PALLET_BOX_USAGE_961",
};
